import { Assumptions, Content, ContentProps } from '~/components';
import { StyledContainer } from './styles';

export const PageLayout = ({ children, ...otherProps }: ContentProps) => {
    const id = 'main-content-title';
    return (
        <Content {...otherProps}>
            <StyledContainer aria-labelledby={id}>
                {children}
                <Assumptions />
            </StyledContainer>
        </Content>
    );
};
